export const SAVE_ALL_NOTIFICATIONS = 'SAVE_ALL_NOTIFICATIONS'